import { render } from "./ProjectSaved.vue?vue&type=template&id=dc2935e8&scoped=true"
import script from "./ProjectSaved.vue?vue&type=script&lang=js"
export * from "./ProjectSaved.vue?vue&type=script&lang=js"

import "./ProjectSaved.vue?vue&type=style&index=0&id=dc2935e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc2935e8"]])

export default __exports__